import { setMenuSelected } from '@redux/actions/menuAction';
// import moment from 'moment';
// import { DATE_FORMAT } from 'config';
import { deleteOne, exportData, getList } from 'api/facilityemissionApi';
import Clearfix from 'components/elements/clearfix';
import EmissionTypeSelect from 'components/elements/select-emission-type';
import { IS_ENTERPRISE } from 'config';
import { COLOR } from 'config';
import slug from 'constants/slug';
import { BaseListContainer } from 'containers/BaseContainer/BaseListContainer';
import PageLockHOC from 'hoc/pageLock';
import { get as _get } from 'lodash';
import PropTypes from 'prop-types';
import { createForm } from 'rc-form';
import Message from 'rc-message';
import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import styled from 'styled-components';
import { getLabelIndustrialArea } from 'utils/misc';

const NameContainer = styled.div`
  color: ${COLOR.SECOND_COLOR};
  text-decoration: underline;
`;

@PageLockHOC(['facilityEmission.view'])
class FacilityemissionList extends BaseListContainer {
  static propTypes = {
    facilityId: PropTypes.string,
    hideRightHeaderContent: PropTypes.bool,
  };

  constructor(props) {
    const funcApi = {
      getList,
      exportData,
    };
    const columns = [
      {
        dataField: 'facility.FacilityNameFull',
        text: 'Tên cơ sở/dự án',
        formatter: (cell, row) => {
          return (
            <Link
              target='_blank'
              to={slug.FACILITY_EMISSTION.VIEW_WITH_ID + row._id}
            >
              <NameContainer>{cell}</NameContainer>
            </Link>
          );
        },
      },
      ...(!IS_ENTERPRISE && [
        {
          dataField: 'facility.organizationName',
          text: 'Tên doanh nghiệp',
          formatter: (cell, row) => {
            return <div>{cell ? cell : ''}</div>;
          },
        },
      ]),

      {
        dataField: 'facility.industrialArea',
        text: getLabelIndustrialArea(),
        formatter: (cell, row) => {
          // console.log(row, '==row==')
          return <div>{_.get(row, 'facility.industrialArea.Name')}</div>;
        },
      },
      {
        dataField: 'facility.sector',
        text: 'Ngành/Nghề',
        formatter: (cell, row) => {
          return <div>{_.get(row, 'facility.sector.Name')}</div>;
        },
      },
      // {
      //   dataField: 'IssueDate',
      //   text: 'Ngày cấp',
      //   formatter: (cell, row) => {
      //     return <div>{ cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
      //   },
      // },
      {
        dataField: 'emissionType',
        text: 'Loại chất thải',
        formatter: (cell, row) => {
          return <div>{cell ? cell.Name : ''}</div>;
        },
      },
      {
        dataField: 'DataValue',
        text: 'Giá trị',
        formatter: (cell, row) => {
          return <div>{cell ? cell : ''}</div>;
        },
      },
      {
        dataField: 'url',
        text: 'Đường dẫn (URL)',
        formatter: (cell, row) => {
          return (
            <a href={`${cell}`} target='_blank'>
              <NameContainer>{cell}</NameContainer>
            </a>
          );
        },
      },
    ];
    super(
      props,
      funcApi,
      columns,
      `${slug.FACILITY_EMISSTION.CREATE}?facilityId=${props.facilityId}`,
      'facilityEmission',
      null,
      true
    );

    this.state = {
      ...this.state,
      valueSearch: {
        facility: this.props.facilityId,
      },
    };
  }

  renderSearchContainer() {
    return <div>{super.renderSearchContainer()}</div>;
  }

  handelSubmitSearch = (values) => {
    values.emissionType = _get(values.emissionType, 'value');
    super.handelSubmitSearch(values);
  };

  renderSearchExpandContainer = () => {
    return (
      <div>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <EmissionTypeSelect
              fieldForm={{
                form: this.props.form,
                name: 'emissionType',
              }}
            />
          </Col>
        </Row>
      </div>
    );
  };

  handelDelete = (_id) => {
    if (this.ConfirmElm && this.ConfirmElm.showConfirm) {
      this.ConfirmElm.showConfirm({
        content: 'Bạn có muốn xoá ',
        cb: async (value) => {
          if (value) {
            const res = await deleteOne(_id);
            if (res.success) {
              Message.success({ content: 'Thành Công' });
              this.fetData();
            }
            if (res.error) Message.error({ content: res.message });
          }
        },
      });
    }
  };
}

const mapStateToProps = (state) => ({
  menuStore: state.menu,
});

const mapDispatchToProps = {
  setMenuSelected,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(createForm()(FacilityemissionList))
);



// WEBPACK FOOTER //
// ./src/containers/FacilityemissionContainer/FacilityemissionList/index.js